import React, { useState, useEffect } from 'react';
import ServiceModal from './components/ServiceModal';
import { useLanguage } from './LanguageContext';
import OptimizedImage from './components/OptimizedImage';

// Import images from new location with correct folder structure
import service1 from './assets/services/1_Krankengymnastik/iStock-1169353840.webp';
import service2 from './assets/services/2_Manuelle_Therapie/iStock-1084926058.webp';
import service3 from './assets/services/3_KG_am_Gerät/shutterstock_2530424977.webp';
import service4 from './assets/services/4_Lymphdrainage/iStock-114280754.webp';
import service5 from './assets/services/5_Kiefergelenk/iStock-956623082.webp';
import service6 from './assets/services/6_Wärme/Fango.webp';
import service7 from './assets/services/7_Kälte/iStock-1435234026.webp';
import service8 from './assets/services/8_Elektro/shutterstock_1640844673.webp';
import service9 from './assets/services/9_Faszientechnik/iStock-2175835626.webp';
import service10 from './assets/services/10_Kinesiotaping/AdobeStock_326808139.webp';
import service11 from './assets/services/11_Medical_Flossing/image-683x455(4).webp';
import service12 from './assets/services/12_Personal_Training/iStock-1188436473.webp';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const { t } = useLanguage();

  const services = [
    {
      title: t('service1'),
      image: service1,
      description: t('service1Desc')
    },
    {
      title: t('service2'),
      image: service2,
      description: t('service2Desc')
    },
    {
      title: t('service3'),
      image: service3,
      description: t('service3Desc')
    },
    {
      title: t('service4'),
      image: service4,
      description: t('service4Desc')
    },
    {
      title: t('service5'),
      image: service5,
      description: t('service5Desc')
    },
    {
      title: t('service6'),
      image: service6,
      description: t('service6Desc')
    },
    {
      title: t('service7'),
      image: service7,
      description: t('service7Desc')
    },
    {
      title: t('service8'),
      image: service8,
      description: t('service8Desc')
    },
    {
      title: t('service9'),
      image: service9,
      description: t('service9Desc')
    },
    {
      title: t('service10'),
      image: service10,
      description: t('service10Desc')
    },
    {
      title: t('service11'),
      image: service11,
      description: t('service11Desc')
    },
    {
      title: t('service12'),
      image: service12,
      description: t('service12Desc')
    },
  ];

  const containerStyle = {
    fontFamily: 'Sora, sans-serif',
    padding: '1rem',
  };

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  };

  const headingStyle = {
    color: '#666666',
    fontWeight: '500',
    lineHeight: '1.1',
    letterSpacing: '-1px',
    fontSize: '1.8rem',
    textAlign: 'center',
    padding: '0.3rem 0 1rem 0'
  };

  const textStyle = {
    color: '#666666',
    lineHeight: '1.6',
    fontWeight: '300',
    textAlign: 'center',
    padding: '0 1rem 1.4rem 1rem',
    fontSize: '1rem',
  };

  const servicesGridStyle = {
    display: 'grid',
    gap: '10px',
    margin: '0 auto',
    maxWidth: '1200px',
    padding: '0 20px',
    justifyContent: 'center',
  };

  const serviceCardStyle = {
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '5px',
    overflow: 'hidden',
    width: '100%',
    aspectRatio: '1',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    transition: 'transform 0.3s, box-shadow 0.3s',
    outline: 'none',
    WebkitTapHighlightColor: 'transparent',
    '&:focus': {
      outline: 'none',
      boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
    },
    '&:active': {
      transform: 'scale(0.98)',
    }
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const cardTitleStyle = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    padding: '15px 5px',
    textAlign: 'center',
    color: '#666666',
    fontSize: '12px',
    fontWeight: '500',
    fontFamily: 'Sora, sans-serif',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  return (
    <section id="leistungen" style={containerStyle}>
      <style>{`
        .services-grid {
          display: grid;
          gap: 10px;
          margin: 0 auto;
          max-width: 1200px;
          padding: 0 20px;
          justify-content: center;
          grid-template-columns: repeat(2, 1fr);
        }
        @media (min-width: 700px) {
          .services-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (min-width: 1000px) {
          .services-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }
      `}</style>
      <div style={contentStyle}>
        <h1 style={headingStyle}>{t('services')}</h1>
        <p style={textStyle}>
          {t('servicesIntro')}
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              style={serviceCardStyle} 
              onClick={() => setSelectedService(service)}
            >
              <OptimizedImage src={service.image} alt={service.title} style={imageStyle} />
              <div style={cardTitleStyle}>{service.title}</div>
            </div>
          ))}
        </div>
      </div>
      <ServiceModal
        isOpen={selectedService !== null}
        onClose={() => setSelectedService(null)}
        title={selectedService?.title}
        description={selectedService?.description}
      />
    </section>
  );
};

export default Services;